import { fromJS } from 'immutable';
import * as actionTypes from '../../constants/daySheetActionTypes';

const initialState = fromJS({
  list: [],
  isLoading: false,
});

export function daySheetTotalByDateRangeReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_DS_TOTAL_BY_DATE_RANGE: {
      return state.set('list', fromJS(action.payload));
    }
    case actionTypes.GET_DS_TOTAL_BY_DATE_RANGE_LOADING: {
      return state.set('isLoading', action.payload);
    }
    case actionTypes.CLEAR_DS_TOTAL_BY_DATE_RANGE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export default daySheetTotalByDateRangeReducer;
